<template>
  <v-app :class="{'loginColor': $route.name == 'Login' || $route.name == 'Home' || $route.name == 'UserPortalLogin', 'white ': $route.name != 'login'}" min-width="1500px">
    <Navbar v-if ="$store.state.currentOrg && showNavbar" :key="$store.state.currentOrg.org.id + ':' + ($store.state.currentOrg.org.frontendRoutes || []).join(',')"/>
    <UserPortalNavbar v-else-if="$store.state.currentOrg===null && showUserPortalNavbar===true" :key="$store.state.user.id"/>

    <v-content>
       <transition name="slide-right">
      <router-view v-if="$route.name == 'Login' || $route.name == 'Home' || $route.name == 'UserPortalLogin' || $route.name == 'Process'"></router-view>
      <transition  v-else-if="$store.state.currentOrg!==null"  name="fade" mode="out-in">
      <router-view :key="$store.state.currentOrg" class="compact-form"></router-view>
      </transition>
      <transition v-else name="fade" mode="out-in">
      <router-view></router-view>
      </transition>
       </transition>
    </v-content>
  </v-app>
  
</template>

<script>
import Navbar from '@/components/Navbar'
import UserPortalNavbar from '@/components/UserPortalNavbar'

export default {
  name: 'App',
  components: { 
    Navbar,
    UserPortalNavbar
  },
  data () {
    return {
      showUserPortalNavbar: false,
      showNavbar: false,
      colour: "background-color: #03a5fc"
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(value) {
        if (
          value.name === "Login" ||
          value.name === "Home" || value.name === "UserPortalLogin"
        ) {
          this.showNavbar = false;
        } else {
          this.showNavbar = true;
        }
         if (
          value.name === "UserPortalLogin" || value.name === "Login" ||
          value.name === "Home"
        ) {
          this.showUserPortalNavbar = false;
        } else if(value.name === "UserPortal" || value.name === "UserPortalServices" || value.name === "UserPortalOrders") {
          this.showUserPortalNavbar = true;
        }
      }
    },
  },
  created(){
    console.log(this.$store.state)
    this.$eventSignal.$on('loginSuccessful',async ()=>{
      // this.$router.go(0);
      await window.location.reload(true) 
      })
        if (this.$workbox) {
      this.$workbox.addEventListener("waiting", () => {
        this.showUpgradeUI = true;
      });
    }
  },
  methods:{
     async accept() {
      this.showUpgradeUI = false
      await this.$workbox.messageSW({ type: "SKIP_WAITING" });
    },  
    async update(){
      await this.$forceUpdate();
    }
  }
}
</script>
<style>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
  font-size: 12px !important;
  height: 35px !important;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
  font-size: 12px !important;
  height: 35px !important;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.v-chip.Active {
  background: #1ebb2c;
}
.v-chip.Inactive {
  background: #f0121e;
}
.v-chip.BAS {
  background: #155cc7;
}
.v-chip.installFee {
  background: #0e8bd3;
}
.v-chip.activationFee {
  background: #0fc5f3;
}
.v-chip.tvOverFibre {
  background: #b8c417;
}
.v-chip.gtuIncluded {
  background: #dfc013;
}
tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, .02);
  /* font-size: 12px !important; */
}
tbody td {
   font-size: 12px !important;
  height: 35px !important;
  max-width: 350px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.compact-form {
  padding: 10px
    /* transform: scale(0.98);
    transform-origin: top center; */
}
.standardColor {
  background-color: rgb(87, 86, 86);
}

.loginColor {
    background-color: #333333;

  }
.fade-enter-active, .fade-leave-active {
    transition: opacity .3s
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
    opacity: 0
}

</style>
